import { jsx as _jsx } from "react/jsx-runtime";
const Select = ({
  options,
  name,
  value,
  onChange
}) => {
  return /*#__PURE__*/_jsx("div", {
    className: "select-wrapper",
    style: {
      position: 'relative',
      display: 'inline-block'
    },
    children: /*#__PURE__*/_jsx("select", {
      name: name,
      value: value,
      onChange: onChange,
      children: options.map(o => /*#__PURE__*/_jsx("option", {
        value: o.value,
        children: o.text
      }, o.value))
    })
  });
};
export default Select;